import _ from 'underscore';
import { typeField } from './type';
import { normalizeControl } from './control';

/**
 * normalize value messages to array, since value could not be
 * nessasary string, object is not generic enough
 * @private
 * @param {String[]|Object|String} valueMessages - message of value
 * @param {String[]} values -list of value
 * @returns {String[]} - return message in string array
 */
function normalizeValueMessages(valueMessages, values) {
  if (_.isArray(valueMessages)) {
    return valueMessages;
  } else if (_.isObject(valueMessages)) {
    return _.map(values, value => valueMessages[value]);
  } else if (_.isString(valueMessages)) {
    return [valueMessages];
  }

  return valueMessages;
}

/**
 * generate filed options for fields
 * @private
 * @param {JsonSchema} schema - entity define
 * @param {Field[]} fields - list of Field
 * @param {String} prefix - random string as id prefix
 * @param {S$I18n} s$i18n - provide callback property to get string
 * @returns {FieldOption[]} - return field option array for each field in fields
 */
export function generateFieldOptions(schema, fields, prefix, s$i18n) {
  return _.map(fields, (field) => {
    const fieldObject = _.isString(field) ? { property: field } : field;

    if (!_.isEmpty(fieldObject.fields)) { // has subfields
      const subFields = generateFieldOptions(schema, fieldObject.fields, prefix, s$i18n);
      const property = _.uniqueId(_.pluck(subFields, 'property').join('')); // if subfields has only one field, the name will be conflicted with property

      return _.extend({}, fieldObject, {
        control: { builtInControl: fieldObject.type },
        property,
        id: `${prefix}-${property}`,
        hasSubFields: true,
        fields: subFields,
      });
    }

    const type = schema.name;
    const {
      property,
    } = fieldObject;
    const propertySchema = schema.properties[property] || {};
    const typeOptions = typeField(propertySchema) || {};
    const values = fieldObject.values || typeOptions.values;
    const valueMessages = normalizeValueMessages(fieldObject.valueMessages, values) ||
      _.map(values, _.partial(s$i18n.value, type, property));

    // Common options for all fields
    const commonOptions = {
      showLabel: true,
      schema: propertySchema,
      message: valueMessages[0],
      id: `${prefix}-${property}`,
      label: s$i18n.property(type, property),
      visible: true,
      required: Boolean(propertySchema.required || _.contains(schema.required, property)),
    };

    const normalizedOptions = {
      valueMessages,
    };


    const finalField = _.extend(commonOptions, typeOptions, fieldObject, normalizedOptions);

    finalField.control = normalizeControl(finalField, type);

    return finalField;
  });
}
